import { PAYMENT_TYPE } from './PaymentModel';

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum RECURRING_FREQUENCY {
  daily = 'daily',
  weekly = 'weekly',
  biweekly = 'biweekly',
  monthly = 'monthly',
  yearly = 'yearly',
}

export const RECURRING_FREQUENCY_LIST: RECURRING_FREQUENCY[] = [
  RECURRING_FREQUENCY.daily,
  RECURRING_FREQUENCY.weekly,
  RECURRING_FREQUENCY.biweekly,
  RECURRING_FREQUENCY.monthly,
  RECURRING_FREQUENCY.yearly,
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum RECURRING_STATE {
  active = 'active',
  stopped = 'stopped',
  expired = 'expired',
  deleted = 'deleted',
}

export interface RecurringModel {
  id?: number,
  title?: string,
  amount?: number,
  frequency?: RECURRING_FREQUENCY,
  start_date?: string,
  next_date?: string,
  end_date?: string | null,
  state?: RECURRING_STATE,
  contact_id?: number | null,
  contact_first_name?: string | null,
  contact_last_name?: string | null,
  contact_company_name?: string | null,
  contact_email?: string | null,
  contact_mobile_phone?: string | null,
  create_invoice?: boolean,
  create_payment?: boolean,
  send_invoice_by_email?: boolean,
  source?: 'purchase' | 'invoice' | 'admin',
  payment_type?: PAYMENT_TYPE | null,
  payment_info_id?: number | null,
  payment_gateway_id?: number | null,
  currency_id?: number | null,
  bank_account_id?: number | null,
  cc_expiration?: string | null,
  invoice_id?: number | null,
  invoice?: any,
  order?: any,
  payment_id?: number | null,
  last_invoice_status?: string | null,
  last_payment_status?: string | null,
  invoice_counter?: number,
  payment_counter?: number,
  invoice_failure_count?: number,
  payment_failure_count?: number,
}

export default RecurringModel;

export type RecurringsModel = {
  [id: number] :RecurringModel
};

export type RecurringPayload = RecurringModel;
